module.exports = __webpack_public_path__ + "img/stateOneDesignate.bcd1f247.png";